import { useTheme } from '../../design/theme.ts'
import type { ThemeMode } from '../../design/theme.ts'
import { Menu, MenuRadioGroup, MenuRadioItem } from './Menu.tsx'

const LABEL: Record<ThemeMode, string> = {
  system: 'sistema',
  dark: 'escuro',
  light: 'claro',
}

const MODES: readonly ThemeMode[] = ['system', 'dark', 'light']

function isMode(value: string): value is ThemeMode {
  return MODES.some((mode) => mode === value)
}

export function ThemeToggle() {
  const { mode, setMode } = useTheme()

  return (
    <Menu trigger={<span>tema · {LABEL[mode]}</span>} label="Escolher tema">
      <MenuRadioGroup
        value={mode}
        onValueChange={(value) => {
          if (isMode(value)) setMode(value)
        }}
      >
        {MODES.map((option) => (
          <MenuRadioItem key={option} value={option}>
            {LABEL[option]}
          </MenuRadioItem>
        ))}
      </MenuRadioGroup>
    </Menu>
  )
}
